import { Button, Spinner } from "react-bootstrap";
import styles from "./common.module.css";

const CustomButton = ({
  classes,
  title,
  disabled,
  onClick,
  tabIndex,
  loading,
  margin,
}) => {
  return (
    <Button
      className={`${styles.button} ${classes}`}
      tabIndex={tabIndex}
      disabled={disabled}
      style={{ margin: margin }}
      onClick={onClick}
    >
      {loading && (
        <Spinner
          animation="border"
          size="sm"
          style={{ width: "12px", height: "12px", marginRight: "5px" }}
        />
      )}
      {title}
    </Button>
  );
};

export default CustomButton;
